"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNativeBalance = void 0;
var core_1 = require("@usedapp/core");
var utils_1 = require("ethers/lib/utils");
var useNativeBalance = function useNativeBalance() {
  var _ref = (0, core_1.useEthers)(),
    account = _ref.account;
  var nativeBalance = (0, core_1.useEtherBalance)(account);
  if (nativeBalance) {
    return (0, utils_1.formatEther)(nativeBalance);
  }
};
exports.useNativeBalance = useNativeBalance;